import * as THREE from 'three';
import { logDebug } from '../../utils/logger';

export default function setupCamera(): THREE.PerspectiveCamera {
  const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
  camera.position.set(0, 60, 0);
  camera.lookAt(0, 0, 0);

  logDebug('Camera: Created camera at position:', camera.position);
  logDebug('Camera: Looking at:', new THREE.Vector3(0, 0, 0));
  logDebug('Camera: FOV:', camera.fov, 'Aspect:', camera.aspect);

  return camera;
}
